<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          <base-material-stats-card
            color="error"
            icon="mdi-cash-remove"
            title="Rejections"
            :value="getsnapdata.msg_count_rejected.toString()"
            sub-icon="mdi-calendar"
            sub-text="Last Hour"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          <base-material-stats-card
            color="success"
            icon="mdi-cash-plus"
            title="Notes Inserted"
            :value="getsnapdata.msg_count_notein.toString()"
            sub-icon="mdi-calendar"
            sub-text="Last Hour"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          <base-material-stats-card
            color="purple"
            icon="mdi-antenna"
            title="Safe Pings"
            :value="getsnapdata.msg_count_ping.toString()"
            sub-icon="mdi-calendar"
            sub-text="Last Hour"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          <base-material-stats-card
            color="yellow darken-2"
            icon="mdi-alert"
            title="Note Jams"
            :value="getsnapdata.msg_count_notejams.toString()"
            sub-icon="mdi-calendar"
            sub-text="Last Hour"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          <base-material-stats-card
            color="pink darken-2"
            icon="mdi-handshake"
            title="Data Requests"
            :value="getsnapdata.msg_data_exports.toString()"
            sub-icon="mdi-calendar"
            sub-text="Last Hour"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
          lg="4"
        >
          <base-material-stats-card
            color="blue darken-3"
            icon="mdi-database-import"
            title="Data Imports"
            :value="getsnapdata.msg_data_imports.toString()"
            sub-icon="mdi-calendar"
            sub-text="Last Hour"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          class="xs"
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-cogs"
            inline
            title="System Performance"
          >
            <apexchart
              type="line"
              height="350"
              :options="chartOptionsMessages"
              :series="getmessagedata"
            />
          </base-material-card>
        </v-col>
        <v-col
          class="xs"
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-cogs"
            inline
            title="Message Processing"
          >
            <apexchart
              type="bar"
              height="350"
              :options="chartOptions"
              :series="getsystemdata"
            />
          </base-material-card>
        </v-col>
        <v-col
          class="xs"
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-cogs"
            inline
            title="Total Cash In (EOD Sums)"
          >
            <apexchart
              type="bar"
              height="350"
              :options="chartOptionsTotalCashTest"
              :series="getdailytotals"
            />
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  var numeral = require('numeral')

  export default {

    name: 'Locations',

    data () {
      return {
        search: '',
        emailsSubscriptionChart: {
          data: {
            labels: ['Ja', 'Fe', 'Ma', 'Ap', 'Mai', 'Ju', 'Jul', 'Au', 'Se', 'Oc', 'No', 'De'],
            series: [
              [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895]

            ]
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.none(),
            axisX: {
              showGrid: false
            },
            low: 0,
            high: 1000,
            chartPadding: {
              top: 0,
              right: 5,
              bottom: 0,
              left: 0
            }
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        loading: false,
        sites: this.$store.getters.loadedSites,
        profiles: this.$store.getters.loadedSiteProfiles,
        totalcount: 0,
        locations: [],
        perfdata: [{
          name: 'Pings',
          data: [44, 55, 41, 67, 22, 43, 21, 49]
        }, {
          name: 'Cash Held',
          data: [13, 23, 20, 8, 13, 27, 33, 12]
        }, {
          name: 'Note Reject',
          data: [11, 17, 15, 15, 21, 14, 15, 13]
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            stackType: '100%'
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }],
          xaxis: {
            labels: {
              formatter: function (value) {
                return moment(value).format('YYYY-MM-DD: HH:mm')
              }
            },
            categories: ['2011 Q1', '2011 Q2', '2011 Q3', '2011 Q4', '2012 Q1', '2012 Q2',
                         '2012 Q3', '2012 Q4'
            ],
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'bottom',
            offsetX: 0,
            offsetY: 0
          },
        },
        chartOptionsTotalCashTest: {
          chart: {
            height: 350,
            type: 'bar',
            stacked: false,
          },
          plotOptions: {
            bar: {
              columnWidth: '50%',
            },
          },
          stroke: {
            width: [0, 3, 9],
          },
          title: {
            text: 'Total Cash In By Date'
          },
          colors: ['#77B6EA', '#fa075c'],
          tooltip: {
            theme: 'light',
          },
          fill: {
            opacity: 1
          },
          dataLabels: {
            enabled: false,
            enabledOnSeries: []
          },
          // labels: ['01 Jan 2001', '02 Jan 2001', '03 Jan 2001', '04 Jan 2001', '05 Jan 2001', '06 Jan 2001', '07 Jan 2001', '08 Jan 2001', '09 Jan 2001', '10 Jan 2001', '11 Jan 2001', '12 Jan 2001'],
          xaxis: {
            type: 'datetime',
            categories: [],

          },
          yaxis: [{
            title: {
              text: 'Cash Total Estate',
            },
            labels: {
              formatter: function (value) {
                return numeral(value).format('0,0')
              }
            }

          }, ]
        },
        chartOptionsTotalCash: {
          chart: {
            type: 'line',
            height: 350,
            stacked: false,
            toolbar: {
              show: true,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
              },
            },
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }],
          yaxis: {
            labels: {
              formatter: function (value) {
                return numeral(value).format('$0,0.00')
              }
            },
          },
          xaxis: {
            labels: {
              formatter: function (value) {
                return moment(value).format('YYYY-MM-DD')
              },
              hideOverlappingLabels: true,
              trim: true,
              show: false,
            },
            categories: ['2011 Q1', '2011 Q2', '2011 Q3', '2011 Q4', '2012 Q1', '2012 Q2',
                         '2012 Q3', '2012 Q4'
            ],
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'bottom',
            offsetX: 0,
            offsetY: 0
          },
        },
        chartOptionsMessages: {
          chart: {
            type: 'line',
            height: 350,
            stacked: false,
          },
          responsive: [{
            breakpoint: 480,
            options: {
              legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
              }
            }
          }],
          xaxis: {
            labels: {
              formatter: function (value) {
                return moment(value).format('YYYY-MM-DD: HH:mm')
              }
            },
            categories: ['2011 Q1', '2011 Q2', '2011 Q3', '2011 Q4', '2012 Q1', '2012 Q2',
                         '2012 Q3', '2012 Q4'
            ],
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'bottom',
            offsetX: 0,
            offsetY: 0
          },
        },
        locationHeaders: [
          {
            sortable: true,
            text: 'Sites ID',
            value: 'idnum'
          },
          {
            sortable: false,
            text: 'Safe ID',
            value: 'safeid'
          },
          {
            sortable: true,
            text: 'Version',
            value: 'version'
          },
          {
            sortable: false,
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Rej Today',
            value: 'rejcount',
            align: 'center'
          },
          {
            sortable: true,
            text: 'Last Comms',
            value: 'lastcoms',
            align: 'center'
          },
          {
            sortable: true,
            text: 'Server Time',
            value: 'servertime',
            align: 'center'
          },
          {
            sortable: true,
            text: 'Time Span',
            value: 'ago',
            align: 'center'
          }
        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
      }
    },
    computed: {
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
      getsnapdata () {
        return this.$store.getters.getSystemSnap
      },
      getsumtotals () {
        let csv
        csv = this.$store.getters.gettotalcash
        return csv
      },
      getdailytotals () {
        let times
        times = ['one', 'two']
        this.chartOptionsTotalCashTest.xaxis.categories = this.$store.getters.gettotalcash.map(entry => entry.date)
        let cash
        cash = this.$store.getters.gettotalcash.map(entry => entry.value)
        let rec = {
          name: 'Total Cash',
          data: cash
        }
        return [rec]
      },
      getmessagedata () {
        let data = this.$store.getters.getSystemData
        let messagecount = data.map(element => element.totalmessages)
        this.totalcount = messagecount.reduce((acc, val) => acc + val, 0)

        let disconects = data.map(element => element.mqtt_disco)
        let recon = data.map(element => element.mqtt_recon)
        let times = data.map(element => element.timestamp)
        this.chartOptionsMessages.xaxis.categories = times

        // eslint-disable-next-line no-return-assign
        return this.perfdata = [{
          name: 'Messages',
          data: messagecount
        }, {
          name: 'Disconnects',
          data: disconects
        }, {
          name: 'Reconnects',
          data: recon
        }]
      },
      getsystemdata () {
        let data = this.$store.getters.getSystemData
        let times = data.map(element => element.timestamp)
        this.chartOptions.xaxis.categories = times
        let pings = data.map(element => element.msg_count_ping)
        let cashheld = data.map(element => element.msg_count_cashheld)
        let citmessaaages = data.map(element => element.msg_count_cit)
        let deposits = data.map(element => element.msg_count_deposit)
        let manualdeposits = data.map(element => element.msg_count_manualdeposit)
        let rejections = data.map(element => element.msg_count_rejected)
        let notein = data.map(element => element.msg_count_notein)
        let other = data.map(element => element.totalmessages - (element.msg_count_ping + element.msg_count_notein + element.msg_count_rejected + element.msg_count_manualdeposit + element.msg_count_deposit + element.msg_count_cit + element.msg_count_cashheld))

        // eslint-disable-next-line no-return-assign
        return this.perfdata = [{
          name: 'Pings',
          data: pings
        }, {
          name: 'Cash Held',
          data: cashheld
        }, {
          name: 'CIT Events',
          data: citmessaaages
        }, {
          name: 'Deposits',
          data: deposits
        }, {
          name: 'Manual Deposits',
          data: manualdeposits
        }, {
          name: 'Rejections',
          data: rejections
        }, {
          name: 'Note In',
          data: notein
        }, {
          name: 'Other',
          data: other
        }]
      },
      getlocs () {
        this.locations = []
        let today = moment().format('YYYY-MM-DD')

        let eventlist = this.$store.getters.notereaderevents

        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let name = 'Unknown'
          let loc = this.$store.getters.loadedSites.find(function (site) {
            if (site.idnum === key) {
              return site
            }
          })
          if (loc) {
            name = loc.sitename
          }
          if (value.siteunitsprofile) {
            let rejcount = 0
            let safeid = Object.values(value.siteunitsprofile)[0].crypto_idnum
            this.$log.debug('looking for events for safe ', safeid)
            let events = eventlist.filter(event => event.crypto_idnum === safeid)
            if (events.length > 0) {
              let todaysevents = events.filter(event => event.day === today)
              if (todaysevents.length > 0) {
                this.$log.debug('today is ', today, ' Todays events ', todaysevents)
                rejcount = todaysevents[0].rejcount
                // this.$log.debug('count is ', todaysevents[0].rejcount)
              }
              //
            }
            this.$log.debug('rej count is ', rejcount)

            let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === safeid)
            let version = 'unkown'
            let lastcoms = 'NA'
            let ago = 'undetermined'
            let servertime = 'NA'
            if (rec && rec.heartbeat && rec.servertime) {
              lastcoms = moment(rec.heartbeat).format('YYYY-MM-DD HH:mm:ss')
              ago = moment(rec.heartbeat).fromNow('HH:mm:ss')
              servertime = moment(rec.servertime).format('YYYY-MM-DD HH:mm:ss')
            }
            if (rec && rec.version) {
              version = rec.version
            }
            let status = 'N/A'
            if (rec) {
              let now = Date.now()
              let mContact = moment(rec.heartbeat)
              let mNow = moment(now)
              let duration = moment.duration(mNow.diff(mContact))
              this.$log.debug('minutes since last contact', duration.asMinutes())
              let MINUTES_CONSIDERED_OFFLINE = 60
              // this.lastheartbeat = moment(rec.heartbeat)
              // this.$log.debug('last heartbeat ', this.lastheartbeat)
              if (duration.asMinutes() <= MINUTES_CONSIDERED_OFFLINE) {
                console.log('ONLINE ', duration.asMinutes())
                status = 'Online'
              }
              if (duration.asMinutes() >= MINUTES_CONSIDERED_OFFLINE) { // 60  minutes
                console.log('OFFLINE ', duration.asMinutes())
                status = 'Offline'
              }
            }
            let shop = {
              idnum: key,
              safeid: safeid,
              status: status,
              rejcount: rejcount,
              sitename: name,
              version: version,
              lastcoms: lastcoms,
              servertime: servertime,
              ago: ago
            }
            this.locations.push(shop)
          }
          // this.$log.debug(key,value.siteunitsprofile)
        }
        this.$log.debug('our location map ', this.locations)
        return this.locations
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },
    created () {
      this.loading = true
      this.$store.dispatch('loadsystemtotals')
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.$store.dispatch('loadUserGroups')
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadnotereaderevents')
      this.$store.dispatch('loadsystemdata')
      this.$store.dispatch('loadsystemsnapshot')
      // let j = Object.keys(loadedprofiles)
      // let units = loadedprofiles[j[0]].siteunitsprofile
    },
    beforeDestroy () {
      // this.$store.dispatch('resetsafetransactions')
    },
    methods: {
      generateData (count, yrange) {
        var i = 0
        var series = []
        while (i < count) {
          var x = (i + 1).toString()
          var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min
          series.push({
            x: x,
            y: y
          })
          i++
        }
        return series
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = today + '_eodsummary' + '_' + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      gettotaleodcash () {
        let cash = this.$store.getters.gettotalcash
        console.log(cash)

        return cash
      },
      sitestatus (ssid) {
        this.$log.debug('SSID PASSED ', ssid)
        let crypto_idnum = this.$store.getters.loadedSiteProfiles[ssid].siteunitsprofile[0].crypto_idnum
        let rec = this.$store.getters.getheartbeatvalues.find(element => element.crypto_idnum === crypto_idnum)
        let color
        if (rec) {
          let now = Date.now()
          let delta = (now - rec.heartbeat)
          // this.lastheartbeat = moment(rec.heartbeat)
          // this.$log.debug('last heartbeat ', this.lastheartbeat)
          if (delta <= 3600000) {
            color = 'Online'
          }
          if (delta >= 3600000) { // 60  minutes
            color = 'Offline'
          }
          return color
        }
        return 'N/A'
      },
      getsitelabel (ssid) {
        // return ssid
        let label = 'unknown'
        // get list of sites in the system
        this.$store.getters.loadedSites.filter(function (site) {
          if (site.idnum === ssid) {
            label = site.sitename
          }
        })
        return label
        // loop thru, find name
        // return sitename
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
